import { Auth0ContextInterface } from '@auth0/auth0-react'

export class AuthService {
  private static _instance: AuthService

  private constructor(private auth0Context: Auth0ContextInterface) {}

  public static Build(auth0Context: Auth0ContextInterface) {
    if (!this._instance) {
      this._instance = new AuthService(auth0Context)
    }
  }

  public static GetCurrent() {
    if (!this._instance) {
      console.error('AuthContext was not build.')
      return null
    }

    return this._instance
  }

  public GetAuth0User() {
    return this.auth0Context.user
  }

  public async Logout() {
    this.auth0Context.logout({
      returnTo: `${window.location.origin}`,
    })
  }

  private async loginWithRedirect() {
    await this.auth0Context.loginWithRedirect({
      prompt: 'login',
    })
  }

  public async GetAccessToken() {
    if (!this.auth0Context.isAuthenticated) {
      this.loginWithRedirect()
      return null
    }

    try {
      const token = await this.auth0Context.getAccessTokenSilently({
        audience: 'https://api.rhodium24.io',
      })

      return token
    } catch (err: unknown) {
      if (
        err['error'] === 'login_required' ||
        err['error'] === 'consent_required'
      ) {
        await this.loginWithRedirect()
      } else {
        window.location.replace('/error')
      }
      console.error(err)
      return undefined
    }
  }
}
